module.exports = __webpack_public_path__ + "static/abstract-art2-6d3585c7ee8fd730075ae53ce2fff3c4.webp";